import 'css-chunksrc/client/scenes/calendarHolidaysEdition/form/holiday/styles.scss';export default {
  "holidayForm": "_holidayForm_117tl_1",
  "holidayRow": "_holidayRow_117tl_9",
  "holidayNameInput": "_holidayNameInput_117tl_14",
  "dateTimeInput": "_dateTimeInput_117tl_20",
  "removeButton": "_removeButton_117tl_25",
  "icon": "_icon_117tl_33",
  "removeIcon": "_removeIcon_117tl_38"
};